import React from "react"
import FirebaseProvider from "./Firebase"
import NavBar from "./NavBar"
import Content from "./ContentWrapper"

import Footer from "./Footer"

import Banner from "./Banner"

const LayoutFirebaseStream = ({ children, gradient, transparent, sticky, bgColor, createBoardLink }) => {
  return (
    <>
      <FirebaseProvider>
        <Banner />
        <NavBar gradient={gradient} sticky={sticky} transparent={transparent} bgColor={bgColor} createBoardLink={createBoardLink} />
        <Content>{children}</Content>
        <Footer />
      </FirebaseProvider>
    </>
  )
}
export default LayoutFirebaseStream
